module.exports = __webpack_public_path__ + "Flag-254.eb08be46546f06da0c8b7dda25f741c6.svg";